export const LABELS: any = {
  PNL: 'PNL',
  INTRINSIC: 'Intrinsic',
  ['INTRINSIC (QUOTE)']: 'Intrinsic (Quote)',
  ['INTRINSIC (BASE)']: 'Intrinsic (Base)',
  TIMEVALUE: 'TimeValue',
  PV: 'PV',
  DELTA: 'Delta',
  ['DELTA(STICKY_DELTA)']: 'Delta (Sticky Delta)',
  INTRINSIC_DELTA: 'Intrinsic Delta',
  GAMMA: 'Gamma',
  ['GAMMA(THEO)']: 'Gamma(Theo)',
  ['VEGA(WEIGHTED)']: 'Vega(Weighted)',
  THETA: 'Theta',
  VEGA: 'Vega',
  VOLGA: 'Volga',
  VANNA: 'Vanna',
  CASH: 'Cash',
  FUTURE: 'Futures',
  OPTION: 'Options',
  PERPETUAL: 'Perpertual',
  ['PERPETUAL (LINEAR)']: 'Perpetuals (Linear)',
  DVEGADSPOT: 'DVegaDSpot',
  DDELTADVOL: 'DDeltaDVol',
  ['SETTLEMENT (BASE)']: 'Settlement (Base)',
  ['SETTLEMENT (QUOTE)']: 'Settlement (Quote)',
  SMILE_25: 'Smile 25',
  SKEW_25: 'Skew 25',
};

export const RISK_TYPES_VOLATILITY = [
  'TIMEVALUE',
  'GAMMA',
  'THETA',
  'VEGA',
  'VOLGA',
  'VANNA',
  'VEGA(WEIGHTED)',
  'GAMMA(THEO)',
  'DVEGADSPOT',
  'DDELTADVOL',
  'SETTLEMENT (BASE)',
  'SETTLEMENT (QUOTE)',
  'SMILE_25',
  'SKEW_25',
];

export const CONTRACT_TYPES = {
  FUTURE: 'FUTURE',
  PERPETUAL: 'PERPETUAL',
  TOTAL: 'TOTAL',
  OPTIONS: 'OPTIONS',
  OPTION: 'OPTION',
};

export const DEFAULT_HEADER = [
  -75, -70, -65, -60, -55, -50, -45, -40, -35, -30, -25, -20, -15, -10, -9, -8, -7, -6, -5, -4, -3,
  -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80,
  85, 90, 95, 100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150,
];

export const PORTFOLIO_TABS_NAME = {
  spotLadder: 'SPOT_LADDER',
  spotGrid: 'SPOT_GRID',
  spotTime: 'SPOT_TIME',
  pnlLegacy: 'PNL_LEGACY',
  pnl: 'PNL',
  positionsAndOrders: 'POSITIONS_ORDERS',
  transactions: 'TRANSACTIONS',
  strikeReport: 'STRIKE_REPORT',
};
